import Icons from 'Icons';
import MyButton, { MyButtonLink } from 'components/MyButton/MyButton';
import PageHeader from 'components/PageHeader/PageHeader';
import ShipmentsTable from 'features/dispatch/components/ShipmentsTable/ShipmentsTable';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { usePageTitle } from 'utils/locationHelpers';

export default function ShipmentsPage() {
    usePageTitle('Shipments');
    return (
        <>
            <PageHeader title="Shipments">
                <MyButton
                    label="New Shipment"
                    IconLeft={Icons.Plus}
                    buttonType="Accent"
                    href="create"
                    LinkComponent={MyButtonLink}
                />
            </PageHeader>
            <ShipmentsTable />
            <Outlet />
        </>
    );
}
